/**
 * Filter-bar helpers over the shared topic and time-of-day definitions in
 * `eventTopicData.ts` (mirrored on the API for subscription matching).
 */
import type { ExtractedEvent } from '../types';
import { eventClockMinutes } from './eventTemporal';
import {
  EVENT_TOPICS,
  clockBucket,
  hasBrunchTag,
  isUntimedEvent,
} from './eventTopicData';

export {
  EVENT_TOPICS,
  TIME_OF_DAY_OPTIONS,
  TIME_OF_DAY_VALUES,
  eventTopicIds,
  type EventTopic,
} from './eventTopicData';

const TOPIC_BY_ID = new Map(EVENT_TOPICS.map((t) => [t.id, t]));

export function topicLabel(id: string): string {
  return TOPIC_BY_ID.get(id)?.label ?? id;
}

export function topicIcon(id: string): string {
  return TOPIC_BY_ID.get(id)?.icon ?? '';
}

type TimeInput = Pick<ExtractedEvent, 'startUtc' | 'endUtc' | 'isAllDay' | 'timeAnnounced' | 'tags' | 'eventType'>;

/** Clock bucket from the New York start time; all-day, Time TBA and unreadable starts have none. */
export function eventClockBucket(event: TimeInput): string | null {
  if (isUntimedEvent(event)) return null;
  const minutes = eventClockMinutes({ startUtc: event.startUtc, isAllDay: false });
  return minutes === null ? null : clockBucket(minutes);
}

export function matchesTimeOfDay(event: TimeInput, value: string): boolean {
  if (value === 'brunch') return hasBrunchTag(event);
  return eventClockBucket(event) === value;
}
